export const routesClient = [
  {
    path: "/dugun/:uuid",
    name: "dugun",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/client/dugun/index.vue"),
  },
  {
    path: "/organizasyon/:uuid",
    name: "organizasyon",
    meta: { layout: "blank", public: true },
    component: () => import("@/views/client/organizasyon/index.vue"),
  },
  {
    path: "/resimler/:uuid",
    name: "resimler",
    meta: { public: false },
    component: () => import("@/views/client/resimler/index.vue"),
  },
]
